// import React, { useEffect, useState } from 'react'
// import { useLocation } from 'react-router-dom'
// import SummaryApi from '../common'
// import VerticalCard from '../components/VerticalCard'

// const SearchProduct = () => {
//     const query = useLocation()
//     const [data,setData] = useState([])
//     const [loading,setLoading] = useState(false)

//     console.log("query",query.search)

//     const fetchProduct = async()=>{
//         setLoading(true)
//         const response = await fetch(SummaryApi.searchProduct.url+query.search)
//         const dataResponse = await response.json()
//         setLoading(false)

//         setData(dataResponse.data)
//     }

//     useEffect(()=>{
//         fetchProduct()
//     },[query])

//   return (
//     <div className='container mx-auto p-4'>
//       {
//         loading && (
//           <p className='text-lg text-center'>Loading ...</p>
//         )
//       }
 
//       <p className='text-lg font-semibold my-3'>Search Results : {data.length}</p>

//       {
//         data.length === 0 && !loading && (
//            <p className='bg-white text-lg text-center p-4'>No Data Found....</p>
//         )
//       }


//       {
//         data.length !==0 && !loading && (
//           <VerticalCard loading={ loading} data={data}/>
//         )
//       }

//     </div>
//   )
// }

// export default SearchProduct
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import SummaryApi from '../common'
import VerticalCard from '../components/VerticalCard'
import { motion } from "framer-motion"

const SearchProduct = () => {

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const searchQuery = queryParams.get("q")

  const [data,setData] = useState([])
  const [loading,setLoading] = useState(false)

  const fetchProduct = async()=>{
    setLoading(true)

    const response = await fetch(
      SummaryApi.searchProduct.url + location.search,
      {
        method: "GET",
        credentials : "include"
      }
    )

    const dataResponse = await response.json()

    setData(dataResponse.data || [])
    setLoading(false)
  }

  useEffect(()=>{
    fetchProduct()
  },[location.search])

  return (
    <div className='bg-gray-50 min-h-screen pb-20'>

      <div className='max-w-7xl mx-auto px-4 py-6'>

        {/* 🔥 HEADER */}
        <motion.div
          initial={{ opacity:0, y:20 }}
          animate={{ opacity:1, y:0 }}
          className='mb-6'
        >
          <h1 className='text-xl md:text-2xl font-semibold'>
            Search Results
          </h1>

          <p className='text-gray-500 text-sm mt-1'>
            Showing results for: 
            <span className='text-black font-medium ml-1'>
              "{searchQuery}"
            </span>
          </p>

          <p className='text-sm text-gray-400 mt-1'>
            {data.length} products found
          </p>
        </motion.div>

        {/* 🔥 LOADING SKELETON */}
        {loading && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {Array(8).fill().map((_,i)=>(
              <div key={i} className="bg-white p-4 rounded-xl shadow animate-pulse">
                <div className="h-32 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 mt-3 rounded"></div>
                <div className="h-3 bg-gray-200 mt-2 rounded"></div>
              </div>
            ))}
          </div>
        )}

        {/* ❌ EMPTY STATE */}
        {!loading && data.length === 0 && (
          <div className='bg-white p-8 rounded-xl text-center shadow'>

            <h2 className='text-lg font-semibold'>
              No Results Found 😔
            </h2>

            <p className='text-gray-500 mt-2 text-sm'>
              Try searching with different keywords
            </p>

          </div>
        )}

        {/* ✅ PRODUCTS */}
        {!loading && data.length > 0 && (
          <motion.div
            initial={{ opacity:0 }}
            animate={{ opacity:1 }}
            className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4'
          >
            {data.map((product)=>(
              <VerticalCard key={product._id} data={[product]} />
            ))}
          </motion.div>
        )}

      </div>

    </div>
  )
}

export default SearchProduct